module.exports = __webpack_public_path__ + "img/play-circle-orange.40c56065.png";